module.exports = __webpack_public_path__ + "img/34.18a33e55.jpg";